import { configureStore } from "shared/store";
import { isSurveysApp } from "shared/utils/auth";

const createStore = () => (isSurveysApp() ? configureStore() : null);

export default createStore;
